module.exports = __webpack_public_path__ + "img/09.5925c0ca.png";